import SocialMediaCardStyle from './Style'

export const CardDetails = [
  {
    id: 1,
    icon: SocialMediaCardStyle.InstagramIconStyle,
    platformName: 'Instagram',
    description: 'Business account',
  },
  {
    id: 2,
    icon: SocialMediaCardStyle.FacebookIconStyle,
    platformName: 'Facebook',
    description: 'Page or Group',
  },
  {
    id: 3,
    icon: SocialMediaCardStyle.TwitterIconStyle,
    platformName: 'Twitter',
    description: 'Profile',
  },
  {
    id: 4,
    icon: SocialMediaCardStyle.LinkedInIconStyle,
    platformName: 'LinkedIn',
    description: 'Page or Profile',
  },
  {
    id: 5,
    icon: SocialMediaCardStyle.GoogleIconStyle,
    platformName: 'Google',
    description: 'Google Workspace',
  },
  {
    id: 6,
    icon: SocialMediaCardStyle.RedditIconStyle,
    platformName: 'Reddit',
    description: 'Dive into anything',
  },
  {
    id: 7,
    icon: SocialMediaCardStyle.TikTokIconStyle,
    platformName: 'TikTok',
    description: 'Make your day',
  },
]
